const HERE_ID_REGEX = /^here:[^:]+:[^:]+:([^:]+)/
const PLACE_VS_REGEX = /^s-([-_+/0-9a-zA-Z=]+)([?/].+)?$/
const PLACE_VE_REGEX = /^e-([-_+/0-9a-zA-Z=]+)([?/].+)?$/

export const isEmptyId = (id: string | undefined | null): id is undefined => {
  return id === undefined || id === null || id === ''
}

export const isHereId = (id: string | undefined): boolean => {
  return !isEmptyId(id) && (id.startsWith('here:') || HERE_ID_REGEX.test(id))
}

export const isPlaceVS = (id: string | undefined): id is string => {
  return !isEmptyId(id) && PLACE_VS_REGEX.test(id)
}

export const isPlaceV0 = (id: string | undefined): id is string => {
  return !isEmptyId(id) && id.startsWith('WSID-v0-')
}

export const isPlaceVE = (id: string | undefined): id is string => {
  return !isEmptyId(id) && PLACE_VE_REGEX.test(id)
}

/**
 * Removes the HERE ID prefix from the given id.
 * @example here:pds:place:276u33dv-abfcfd921d89438fa2a9191825e14bfd returns 276u33dv-abfcfd921d89438fa2a9191825e14bfd
 * @param id
 */
export const removeHereIdPrefix = (id: string): string => {
  const idWithoutPrefix = id.match(HERE_ID_REGEX)
  if (idWithoutPrefix === null) {
    throw new Error(`Invalid id: ${id}`)
  }

  return idWithoutPrefix[1]
}
